import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import Text from '../chrome/Text';

const baseContainerStyles = ({ theme }) => css`
  border-top-left-radius: ${theme.borderRadius.giga};
  border-top-right-radius: ${theme.borderRadius.giga};
  background-color: ${theme.colors.red};
  color: ${theme.colors.white};
  padding: ${theme.spacings.byte} ${theme.spacings.kilo};
  text-align: center;
`;

const Container = styled('div')(baseContainerStyles);

const ListHeader = ({ text }) => (
  <Container>
    <Text as='span' size='mega' upper bold noMargin>
      {text}
    </Text>
  </Container>
);

ListHeader.propTypes = {
  text: PropTypes.string,
};

ListHeader.defaultProps = {
  text: 'This is a list header text',
};

export default ListHeader;
